'use client';

import { useRef } from 'react';
import { useLottieLoader } from '@/lib/useLottieLoader';
import { ButtonGroup } from './ButtonGroup';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/all';
import { useGSAP } from '@gsap/react';
import { ourPricingExplainedSectionTitle, ourPricingExplainedSectionCopy } from './ourPricingExplainedSection.copy';
import { Lottie, LottieRefCurrentProps } from '@/components/LottieWrapper';
import { PLAYWRIGHT_IGNORE } from '@/lib/constants';

function OurPricingExplainedSection() {
  const animationData = useLottieLoader('https://lottie.host/d03c4b0d-e860-4e1d-9408-132c484a8995/W6k40rNuGk.json');

  const container = useRef(null);
  const lottieRef = useRef<LottieRefCurrentProps>(null);

  useGSAP(
    () => {
      gsap.registerPlugin(ScrollTrigger);

      ScrollTrigger.create({
        trigger: container.current,
        start: 'top center',
        end: 'bottom center',
        markers: false,
        animation: gsap.timeline({
          defaults: {
            duration: 2,
            ease: 'none',
          },
        }),
        onEnter: () => {
          lottieRef.current?.setDirection(1);
          lottieRef.current?.goToAndPlay(1, true);
        },
        onLeave: () => {
          lottieRef.current?.setDirection(-1);
          lottieRef.current?.play();
        },
        onEnterBack: () => {
          lottieRef.current?.setDirection(1);
          lottieRef.current?.play();
        },
        onLeaveBack: () => {
          lottieRef.current?.setDirection(-1);
          lottieRef.current?.play();
        },
      });
    },
    { scope: container },
  );

  return (
    <section ref={container} className="py-section bg-light-background-100 px-6 text-gray-1 md:px-28 lg:px-28 xl:px-28">
      <div className="mx-auto grid max-w-7xl grid-cols-12 gap-y-6 md:gap-x-10">
        <div className="col-span-full lg:col-span-6 lg:[direction:_rtl] xl:[direction:_rtl]">
          <div data-testid={PLAYWRIGHT_IGNORE} className="w-full lg:w-[140%] xl:w-[140%]">
            <Lottie lottieRef={lottieRef} animationData={animationData} autoPlay={false} loop={false} />
          </div>
        </div>
        <div className="col-span-12 flex flex-col items-center justify-center gap-5 md:items-center md:gap-10 lg:col-span-6 lg:items-start">
          <h2 className="text-h1 text-center lg:text-start">{ourPricingExplainedSectionTitle}</h2>
          <p className="text-eyebrow max-w-[75ch] text-center lg:text-left xl:text-left">
            {ourPricingExplainedSectionCopy}
          </p>
          <ButtonGroup />
        </div>
      </div>
    </section>
  );
}

export default OurPricingExplainedSection;
